export const DashboardRoute = {
  DashboardWallet: (): string => '/dashboard/balance',
  DashboardElectricity: (): string => '/pools/user/power',
  DashboardMiningHashRate: (): string => '/dashboard/assets/total',
  DashboardMiningTotal: (): string => '/dashboard/mined',
};
  